/**
 * The method names guest code may call — the keys of the VM's METHOD TABLE (src/vm/runtime.ts),
 * which gives each its allocation bound (docs/vm-budgets.md). A separate, dependency-free module
 * so the TRANSPILER can route by the same list without importing the VM: three lists (the VM's
 * allowlist, the emitter's INSTANCE_METHODS, and the atoms the emitter special-cased) used to
 * disagree, which is how `arr.push(x)` as a statement escaped the heap budget while the same call
 * inside an expression did not. `guest-methods.test.ts` holds the two to the same set.
 */
export const GUEST_METHODS: ReadonlySet<string> = new Set([
  'abs',
  'acos',
  'acosh',
  'add',
  'array',
  'asin',
  'asinh',
  'assign',
  'at',
  'atan',
  'atan2',
  'atanh',
  'cbrt',
  'ceil',
  'charAt',
  'charCodeAt',
  'clear',
  'clz32',
  'codePointAt',
  'concat',
  'const',
  'copyWithin',
  'cos',
  'cosh',
  'diff',
  'endsWith',
  'entries',
  'enum',
  'error',
  'exp',
  'expm1',
  'fill',
  'flat',
  'floor',
  'format',
  'from',
  'fromCharCode',
  'fromCodePoint',
  'fromEntries',
  'fromExample',
  'fround',
  'getDate',
  'getDay',
  'getFullYear',
  'getHours',
  'getMilliseconds',
  'getMinutes',
  'getMonth',
  'getSeconds',
  'getTime',
  'getTimezoneOffset',
  'getUTCDate',
  'getUTCDay',
  'getUTCFullYear',
  'getUTCHours',
  'getUTCMilliseconds',
  'getUTCMinutes',
  'getUTCMonth',
  'getUTCSeconds',
  'getYear',
  'has',
  'hasOwn',
  'hasOwnProperty',
  'hypot',
  'imul',
  'includes',
  'indexOf',
  'infer',
  'info',
  'intersection',
  'isAfter',
  'isArray',
  'isBefore',
  'isFinite',
  'isInteger',
  'isNaN',
  'isSafeInteger',
  'isValid',
  'isWellFormed',
  'join',
  'keys',
  'lastIndexOf',
  'localeCompare',
  'log',
  'log10',
  'log1p',
  'log2',
  'match',
  'max',
  'min',
  'normalize',
  'now',
  'object',
  'of',
  'padEnd',
  'padStart',
  'parse',
  'parseFloat',
  'parseInt',
  'pop',
  'pow',
  'propertyIsEnumerable',
  'push',
  'random',
  'record',
  'remove',
  'repeat',
  'replace',
  'replaceAll',
  'response',
  'reverse',
  'round',
  'search',
  'setDate',
  'setFullYear',
  'setHours',
  'setMilliseconds',
  'setMinutes',
  'setMonth',
  'setSeconds',
  'setTime',
  'setUTCDate',
  'setUTCFullYear',
  'setUTCHours',
  'setUTCMilliseconds',
  'setUTCMinutes',
  'setUTCMonth',
  'setUTCSeconds',
  'setYear',
  'shift',
  'sign',
  'sin',
  'sinh',
  'slice',
  'sort',
  'splice',
  'split',
  'sqrt',
  'startsWith',
  'stringify',
  'substr',
  'substring',
  'tan',
  'tanh',
  'toArray',
  'toDateString',
  'toExponential',
  'toFixed',
  'toGMTString',
  'toISOString',
  'toJSON',
  'toLocaleDateString',
  'toLocaleLowerCase',
  'toLocaleString',
  'toLocaleTimeString',
  'toLocaleUpperCase',
  'toLowerCase',
  'toPrecision',
  'toReversed',
  'toSorted',
  'toSpliced',
  'toString',
  'toTimeString',
  'toUTCString',
  'toUpperCase',
  'toWellFormed',
  'trim',
  'trimEnd',
  'trimLeft',
  'trimRight',
  'trimStart',
  'trunc',
  'tuple',
  'union',
  'unshift',
  'valueOf',
  'values',
  'warn',
  'with',
])
